// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `#offers-animated-line {
	stroke-dasharray: 4000;
	stroke-dashoffset: 4000;
	animation:
		drawLine 4s linear forwards paused,
		gradientAnimation 4s linear forwards paused;
}

#animated-circle-1,
#animated-circle-2,
#animated-circle-3 {
	animation: circleAppear 0.5s linear forwards paused;
}

@keyframes circleAppear {
	0% {
		opacity: 0;
	}

	25% {
		opacity: 0.2;
	}

	50% {
		opacity: 0.5;
	}

	75% {
		opacity: 0.7;
	}

	100% {
		opacity: 1;
	}
}

#circle-1 {
	animation-delay: 0.2s;
}

#circle-2 {
	animation-delay: 0.8s;
}

#circle-3 {
	animation-delay: 1.5s;
}

@keyframes drawLine {
	to {
		stroke-dashoffset: 0;
	}
}

@keyframes gradientAnimation {
	0% {
		stroke: url(#lineGradient);
	}

	25% {
		stroke: url(#lineGradient);
	}

	100% {
		stroke: url(#lineGradient);
	}
}

#introduction-flying-line-1 {
	stroke-dasharray: 2000;
	stroke-dashoffset: 2000;
	animation: flyLine 4s linear forwards infinite;
}

#introduction-flying-line-2 {
	stroke-dasharray: 2000;
	stroke-dashoffset: 2000;
	animation: flyLine 5s linear forwards infinite;
	animation-delay: 0.5s;
}

#introduction-flying-line-3 {
	stroke-dasharray: 2000;
	stroke-dashoffset: 2000;
	animation: flyLine 4s linear forwards infinite;
	animation-delay: 2s;
}

#introduction-flying-line-4 {
	stroke-dasharray: 2000;
	stroke-dashoffset: 2000;
	animation: flyLine 5s linear forwards infinite;
	animation-delay: 3s;
}

#offers-flying-line-1 {
	stroke-dasharray: 2000;
	stroke-dashoffset: 2000;
	animation: flyLine 4s linear forwards infinite;
}

#offers-flying-line-2 {
	stroke-dasharray: 2000;
	stroke-dashoffset: 2000;
	animation: flyLine 5s linear forwards infinite;
	animation-delay: 1.5s;
}

#usage-flying-line-1 {
	stroke-dasharray: 2000;
	stroke-dashoffset: 2000;
	animation: flyLine 4s linear forwards infinite;
}

#usage-flying-line-2 {
	stroke-dasharray: 2000;
	stroke-dashoffset: 2000;
	animation: flyLine 5s linear forwards infinite;
	animation-delay: 1.5s;
}

#usage-flying-line-3 {
	stroke-dasharray: 2000;
	stroke-dashoffset: 2000;
	animation: flyLine 4s linear forwards infinite;
	animation-delay: 3s;
}

@keyframes flyLine {
	0% {
		stroke-dashoffset: 2000;
	}

	50% {
		stroke-dashoffset: 0;
	}

	100% {
		stroke-dashoffset: -2000;
	}
}

@media (max-width: 950px) {
	#offers-animated-line {
		display: none;
	}

	#animated-circle-1,
	#animated-circle-2,
	#animated-circle-3 {
		display: none;
	}
}
`, "",{"version":3,"sources":["webpack://./src/app/pages/LendingPage/Home/Animations.css"],"names":[],"mappings":"AAAA;CACC,sBAAsB;CACtB,uBAAuB;CACvB;;6CAE4C;AAC7C;;AAEA;;;CAGC,mDAAmD;AACpD;;AAEA;CACC;EACC,UAAU;CACX;;CAEA;EACC,YAAY;CACb;;CAEA;EACC,YAAY;CACb;;CAEA;EACC,YAAY;CACb;;CAEA;EACC,UAAU;CACX;AACD;;AAEA;CACC,qBAAqB;AACtB;;AAEA;CACC,qBAAqB;AACtB;;AAEA;CACC,qBAAqB;AACtB;;AAEA;CACC;EACC,oBAAoB;CACrB;AACD;;AAEA;CACC;EACC,0BAA0B;CAC3B;;CAEA;EACC,0BAA0B;CAC3B;;CAEA;EACC,0BAA0B;CAC3B;AACD;;AAEA;CACC,sBAAsB;CACtB,uBAAuB;CACvB,8CAA8C;AAC/C;;AAEA;CACC,sBAAsB;CACtB,uBAAuB;CACvB,8CAA8C;CAC9C,qBAAqB;AACtB;;AAEA;CACC,sBAAsB;CACtB,uBAAuB;CACvB,8CAA8C;CAC9C,mBAAmB;AACpB;;AAEA;CACC,sBAAsB;CACtB,uBAAuB;CACvB,8CAA8C;CAC9C,mBAAmB;AACpB;;AAEA;CACC,sBAAsB;CACtB,uBAAuB;CACvB,8CAA8C;AAC/C;;AAEA;CACC,sBAAsB;CACtB,uBAAuB;CACvB,8CAA8C;CAC9C,qBAAqB;AACtB;;AAEA;CACC,sBAAsB;CACtB,uBAAuB;CACvB,8CAA8C;AAC/C;;AAEA;CACC,sBAAsB;CACtB,uBAAuB;CACvB,8CAA8C;CAC9C,qBAAqB;AACtB;;AAEA;CACC,sBAAsB;CACtB,uBAAuB;CACvB,8CAA8C;CAC9C,mBAAmB;AACpB;;AAEA;CACC;EACC,uBAAuB;CACxB;;CAEA;EACC,oBAAoB;CACrB;;CAEA;EACC,wBAAwB;CACzB;AACD;;AAEA;CACC;EACC,aAAa;CACd;;CAEA;;;EAGC,aAAa;CACd;AACD","sourcesContent":["#offers-animated-line {\n\tstroke-dasharray: 4000;\n\tstroke-dashoffset: 4000;\n\tanimation:\n\t\tdrawLine 4s linear forwards paused,\n\t\tgradientAnimation 4s linear forwards paused;\n}\n\n#animated-circle-1,\n#animated-circle-2,\n#animated-circle-3 {\n\tanimation: circleAppear 0.5s linear forwards paused;\n}\n\n@keyframes circleAppear {\n\t0% {\n\t\topacity: 0;\n\t}\n\n\t25% {\n\t\topacity: 0.2;\n\t}\n\n\t50% {\n\t\topacity: 0.5;\n\t}\n\n\t75% {\n\t\topacity: 0.7;\n\t}\n\n\t100% {\n\t\topacity: 1;\n\t}\n}\n\n#circle-1 {\n\tanimation-delay: 0.2s;\n}\n\n#circle-2 {\n\tanimation-delay: 0.8s;\n}\n\n#circle-3 {\n\tanimation-delay: 1.5s;\n}\n\n@keyframes drawLine {\n\tto {\n\t\tstroke-dashoffset: 0;\n\t}\n}\n\n@keyframes gradientAnimation {\n\t0% {\n\t\tstroke: url(#lineGradient);\n\t}\n\n\t25% {\n\t\tstroke: url(#lineGradient);\n\t}\n\n\t100% {\n\t\tstroke: url(#lineGradient);\n\t}\n}\n\n#introduction-flying-line-1 {\n\tstroke-dasharray: 2000;\n\tstroke-dashoffset: 2000;\n\tanimation: flyLine 4s linear forwards infinite;\n}\n\n#introduction-flying-line-2 {\n\tstroke-dasharray: 2000;\n\tstroke-dashoffset: 2000;\n\tanimation: flyLine 5s linear forwards infinite;\n\tanimation-delay: 0.5s;\n}\n\n#introduction-flying-line-3 {\n\tstroke-dasharray: 2000;\n\tstroke-dashoffset: 2000;\n\tanimation: flyLine 4s linear forwards infinite;\n\tanimation-delay: 2s;\n}\n\n#introduction-flying-line-4 {\n\tstroke-dasharray: 2000;\n\tstroke-dashoffset: 2000;\n\tanimation: flyLine 5s linear forwards infinite;\n\tanimation-delay: 3s;\n}\n\n#offers-flying-line-1 {\n\tstroke-dasharray: 2000;\n\tstroke-dashoffset: 2000;\n\tanimation: flyLine 4s linear forwards infinite;\n}\n\n#offers-flying-line-2 {\n\tstroke-dasharray: 2000;\n\tstroke-dashoffset: 2000;\n\tanimation: flyLine 5s linear forwards infinite;\n\tanimation-delay: 1.5s;\n}\n\n#usage-flying-line-1 {\n\tstroke-dasharray: 2000;\n\tstroke-dashoffset: 2000;\n\tanimation: flyLine 4s linear forwards infinite;\n}\n\n#usage-flying-line-2 {\n\tstroke-dasharray: 2000;\n\tstroke-dashoffset: 2000;\n\tanimation: flyLine 5s linear forwards infinite;\n\tanimation-delay: 1.5s;\n}\n\n#usage-flying-line-3 {\n\tstroke-dasharray: 2000;\n\tstroke-dashoffset: 2000;\n\tanimation: flyLine 4s linear forwards infinite;\n\tanimation-delay: 3s;\n}\n\n@keyframes flyLine {\n\t0% {\n\t\tstroke-dashoffset: 2000;\n\t}\n\n\t50% {\n\t\tstroke-dashoffset: 0;\n\t}\n\n\t100% {\n\t\tstroke-dashoffset: -2000;\n\t}\n}\n\n@media (max-width: 950px) {\n\t#offers-animated-line {\n\t\tdisplay: none;\n\t}\n\n\t#animated-circle-1,\n\t#animated-circle-2,\n\t#animated-circle-3 {\n\t\tdisplay: none;\n\t}\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
